import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { injectIntl } from "react-intl";
import { TEMPLATE_CREATOR } from "../../../common/constant";
import { DAADLogo } from "../../app/DAADLogo";
import StandardView from "../../common/StandardView";
import FundingAreaContainer from "../fundingArea/FundingAreaContainer";
import SurveySettingsContainer from "../surveySettings/SurveySettingsContainer";
import SurveyFooterContainer from "../surveyView/SurveyFooterContainer";
import SurveyViewContainer from "../surveyView/SurveyViewContainer";
import ActivationInfoDialog from "../templateActivation/ActivationInfoDialog";
import QuestionSyncContainer from "../templateActivation/QuestionSyncContainer";
import TemplateActivationContainer from "../templateActivation/TemplateActivationContainer";
import TemplateListTable from "./TemplateListTable";

/**
 * The component displays survey templates from the server.
 * When compoment was rendered, we will call server to load data.
 */
class TemplateList extends Component {
  constructor(props) {
    super(props);
    this.onNewSurvey = this.onNewSurvey.bind(this);
    this.loadTemplateListFilter = this.loadTemplateListFilter.bind(this);
    this.bodyRef = React.createRef();
    this.handlePageChange = this.handlePageChange.bind(this);
    this.state = {templateActivationInfo: null}
  }

  handlePageChange() {
    this.bodyRef.current?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }

  componentDidMount() {
    const { loadTemplateListFilter } = this.props;
    //We are triggering 'ducks' function, that will make a rest call and get data from the server.
    loadTemplateListFilter();
  }

  onNewSurvey() {
    const { newSurvey } = this.props;
    //triggers new_survey_event.
    newSurvey();
  }

  onHidePreview() {
    const { hidePreviewSurvey } = this.props;
    hidePreviewSurvey();
  }

  render() {
    const {
      templateForActivation,
      showActivationDialog,
      showActivationInfo,
      closeTemplateActivationDialog,
      showSurveyPreview,
      editorPages,
      intl,
      surveyName,
      showSyncDialog,
      closeQuestionSyncDialog,
      closeActivationInfoDialog
    } = this.props;

    const template = { pages: editorPages };
    const confirmLabel = intl.formatMessage({ id: "app.common.Close" });

    return (
      <StandardView
        id="templates"
        titleKey="templateList.title"
        actions={[
          {
            labelKey: "templateList.new.template",
            onClick: this.onNewSurvey,
            icon: <FontAwesomeIcon icon={faPlus} className="me-2" />,
            roles: [TEMPLATE_CREATOR]
          }
        ]}
      > 
        {showSurveyPreview && (
          <Modal show className="modal-full" scrollable onHide={this.onHidePreview.bind(this)}>
            <Modal.Header className="bg-light" closeButton>
              <Modal.Title>
                <DAADLogo />
                {surveyName}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body ref={this.bodyRef}>
              <SurveyViewContainer
                onPageChange={this.handlePageChange}
                surveyTemplate={template}
                onConfirm={this.onHidePreview.bind(this)}
                confirmLabel={confirmLabel}
              />
            </Modal.Body>
            <Modal.Footer className="bg-dark text-light">
              <SurveyFooterContainer
                onConfirm={this.onHidePreview.bind(this)}
                confirmLabel={confirmLabel}
                surveyTemplate={template}
              />
            </Modal.Footer>
          </Modal>
        )}

        <SurveySettingsContainer />

        {templateForActivation &&
          <>
            <TemplateActivationContainer
              show={showActivationDialog}
              template={templateForActivation}
              close={closeTemplateActivationDialog}
            />
            
            <ActivationInfoDialog 
              show={showActivationInfo}
              template={templateForActivation} 
              activationHistory={this.props.activationHistory}
              closeDialog={closeActivationInfoDialog}
              intl={intl}
            />

            <QuestionSyncContainer 
              show={showSyncDialog} 
              template={templateForActivation} 
              close={closeQuestionSyncDialog} 
            />
          </>
        }
        
        <Row className="mb-4">
          <Col>
            <FundingAreaContainer
              target="templates"
              filterSelected={() => this.loadTemplateListFilter()}
              preventProjectChoice
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TemplateListTable {...this.props} />
          </Col>
        </Row>
      </StandardView>
    );
  }

  loadTemplateListFilter() {
    const { loadTemplateListFilter } = this.props;
    loadTemplateListFilter();
  }
}

TemplateList.propTypes = {
  newSurvey: PropTypes.func,
  loadTemplateListFilter: PropTypes.func,
  templateForActivation: PropTypes.object,
  showActivationDialog: PropTypes.bool,
  showSyncDialog: PropTypes.bool,
  closeTemplateActivationDialog: PropTypes.func,
  closeQuestionSyncDialog: PropTypes.func,
  hidePreviewSurvey: PropTypes.func,
  editorPages: PropTypes.array,
  surveyName: PropTypes.string,
  showSurveyPreview: PropTypes.bool,
  roles: PropTypes.array,
  intl: PropTypes.object,
  showActivationInfoDialog: PropTypes.func
};

export default injectIntl(TemplateList);
